import { FiFileText, FiCamera, FiCheck, FiImage } from "react-icons/fi";
import { isCheckInOrOut as interventionIsCheckInOrOut } from "../../../../utils/interventionCheckInOut";

export default function ValidateDefault({ sel, imageChange, imagesURLs, loading, userContext }) {
    const isCheckInOrOut = interventionIsCheckInOrOut(sel)
    const isValidated = sel?.valide
    const previousReport = sel?.people?.find(p => p.people === userContext?.user?.id && sel.valide)
    const burl = userContext?.getBurl?.() || ''

    if (isValidated && previousReport) {
        return (
            <div className="validate-default">
                <div className="form-section">
                    <label className="form-label">
                        <FiFileText className="form-icon" />
                        Rapport envoyé
                    </label>
                    <div className="description">
                        {previousReport.report || "Aucun commentaire"}
                    </div>
                    <p className="form-hint">
                        Envoyé le {new Date(previousReport.finishDate).toLocaleDateString('fr-FR')}
                    </p>
                </div>

                {previousReport.photo?.length > 0 && (
                    <div className="form-section">
                        <label className="form-label">
                            <FiImage className="form-icon" />
                            Photos envoyées
                        </label>
                        <div className="imagesList">
                            {previousReport.photo.map((url, index) => (
                                <img key={index} src={burl + "/" + url} alt={`Photo ${index}`} />
                            ))}
                        </div>
                    </div>
                )}
            </div>
        )
    }

    return (
        <div className="validate-default">
            <div className="form-section">
                <label htmlFor="report" className="form-label">
                    <FiFileText className="form-icon" />
                    Rapport de fin d'intervention
                </label>
                <textarea className="form-control" id="report" rows="4" required placeholder="Décrivez ce que vous avez fait..." />
                <p className="form-hint">Inscrivez vos remarques et problèmes rencontrés.</p>
            </div>

            <div className="form-section">
                <label className="form-label">
                    <FiCamera className="form-icon" />
                    Photos de l'intervention
                </label>
                <div className={`file-input-wrapper ${imagesURLs.length > 0 ? 'has-files' : ''}`}>
                    <input id="files" type="file" multiple="multiple" accept="image/*"
                        onChange={imageChange} required={!isCheckInOrOut} />
                    <label htmlFor="files" className="file-input-label">
                        <span className="file-input-icon">
                            <FiCamera />
                        </span>
                        <span className="file-input-text">
                            <span className="file-input-title">
                                {imagesURLs.length > 0 ? `${imagesURLs.length} photo${imagesURLs.length > 1 ? 's' : ''} sélectionnée${imagesURLs.length > 1 ? 's' : ''}` : 'Ajouter des photos'}
                            </span>
                            <span className="file-input-subtitle">
                                {isCheckInOrOut ? 'Optionnel pour check-in/out' : '5 photos minimum'}
                            </span>
                        </span>
                    </label>
                </div>
                <p className="form-hint">
                    Photos prises le jour même reflétant le travail effectué.
                    {!isCheckInOrOut && " Il en faut au moins 5 pour valider."}
                </p>
            </div>

            {imagesURLs.length > 0 && (
                <div className="images-preview">
                    <div className="selected-files-info">
                        <FiCheck />
                        <span>{imagesURLs.length} photo{imagesURLs.length > 1 ? 's' : ''} prête{imagesURLs.length > 1 ? 's' : ''} à envoyer</span>
                    </div>
                    <div className="imagesList">
                        {imagesURLs.map((url, index) => <img key={index} src={url} alt={`Preview ${index}`} />)}
                    </div>
                </div>
            )}
        </div>
    )
}